export enum CompositionType {
    Country = "Country",
    Industry = "Industry",
    Instrument = "Instrument"
}
